import { useUiContext } from "@rotorstudios/fe-ui";
import { Typography } from "@tmca/toyota-kit";
import classNames from "classnames";

import QAWrapperTK from "../../modules/toyota-kit/QAWrapperTK";
import {
  QA_HOME_GAZOO_BODY,
  QA_HOME_GAZOO_HEADING,
  QA_ICON_GAZOO,
} from "../../modules/Data/static";
import UiaIconGAZOO from "../../uiComponents/atoms/uiaIconGAZOO/UiaIconGAZOO";
import "./_UiMGazooRacing.scss";

export type UiMGazooRacingProps = {
  tHeading: string;
  tBody: string;
};

const UiMGazooRacing = ({ tHeading, tBody }: UiMGazooRacingProps) => {
  const { projectClass, breakpointActive } = useUiContext();

  const getComponentClass = () => `${projectClass}_UiMGazooRacing`;

  const getClassName = () => classNames(getComponentClass(), breakpointActive);

  return (
    <section className={`${getClassName()}`}>
      <UiaIconGAZOO
        className={`${getComponentClass()}_Icon`}
        ariaHidden={true}
        qaId={QA_ICON_GAZOO}
      />

      <div className={`${getComponentClass()}_Content`}>
        <QAWrapperTK id={QA_HOME_GAZOO_HEADING}>
          <Typography
            variant="h3"
            component="h3"
            className={`${getComponentClass()}_Content_Heading`}
          >
            {tHeading}
          </Typography>
        </QAWrapperTK>
        <QAWrapperTK id={QA_HOME_GAZOO_BODY}>
          <Typography
            variant="b1"
            component="p"
            className={`${getComponentClass()}_Content_Body`}
          >
            {tBody}
          </Typography>
        </QAWrapperTK>
      </div>
    </section>
  );
};

export default UiMGazooRacing;
